import { useEffect, useState } from 'react'
import { Box, BoxProps } from '@chakra-ui/react'
import { ContainerBase } from '@/components/containers/ContainerBase'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

interface IProps extends BoxProps {
  mdFile: string
}

export const MarkdownLoader = ({ mdFile, ...rest }: IProps) => {
  const [markdown, setMarkdown] = useState('')

  useEffect(() => {
    ;(async () => {
      let contents = (await import(`@/constants/agreements-md/${mdFile}`))
        .default
      setMarkdown(contents)
    })()
  }, [mdFile])

  return (
    <ContainerBase>
      <Box
        whiteSpace="pre-wrap"
        css={{
          '& ol': {
            counterReset: 'item',
            whiteSpace: 'normal',
            marginLeft: '1em',
            '& li': {
              marginTop: '1em',
              counterIncrement: 'item',
              '& ol': {
                marginTop: '1em',
                '& > li': {
                  display: 'block',
                  marginTop: '1em',
                  '&::before': {
                    content: 'counters(item, ".") ". "',
                  },
                },
              },
            },
          },
        }}
        {...rest}
      >
        <ReactMarkdown children={markdown} rehypePlugins={[rehypeRaw]} />
      </Box>
    </ContainerBase>
  )
}
